import { createFileRoute } from '@tanstack/react-router';

import { TutorGlobalConfigTemplate } from '@/features/tutor-ai';

export const Route = createFileRoute('/_authenticated/tutor-ai/config/')({
  component: TutorGlobalConfigTemplate,
});
